export default __webpack_public_path__ + "media/wallpaper/two_thumbnail_large-cfe112da.jpg";